module.exports = __webpack_public_path__ + "static/media/29EUNOG12.d6cf307d.jpg";